module.exports = __webpack_public_path__ + "static/img/shuijiao.58d54e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shuijiao.jpg
// module id = 13
// module chunks = 0